export default __webpack_public_path__ + "static/media/appsIcon.dbed9ec0.svg";